import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./sidebar.css";
import { FaBlog, FaBoxOpen, FaCreditCard, FaImages, FaTachometerAlt, FaTruck, FaUserPlus, FaUserShield, FaUsers } from "react-icons/fa";
import brandLogo from "../../assets/logo.png";

const navItems = [
  { to: "/admin/dashboard", label: "Dashboard", icon: <FaTachometerAlt /> },
  { to: "/admin/products", label: "Products", icon: <FaBoxOpen /> },
  { to: "/admin/products/add", label: "Add Product", icon: <FaUserPlus /> },
  { to: "/admin/orders", label: "Orders", icon: <FaCreditCard /> },
  { to: "/delivery/route", label: "Delivery Route", icon: <FaTruck /> },
  { to: "/delivery/admin", label: "Admin Delivery", icon: <FaUserShield /> },
  { to: "/admin/payments", label: "Payments", icon: <FaCreditCard /> },
  { to: "/admin/blogs", label: "Blogs", icon: <FaBlog /> },
  { to: "/admin/send-campaign", label: "Send Campaign", icon: <FaBlog /> },
  { to: "/admin/users", label: "Users", icon: <FaUsers /> },
  { to: "/admin/design", label: "Design Management", icon: <FaBoxOpen /> },
  { to: "/admin/design/requests", label: "Design Request", icon: <FaBoxOpen /> },
  { to: "/admin/generated-images", label: "Generated Images", icon: <FaBoxOpen /> },
  { to: "/admin/subscribe-management", label: "Subscribe Management", icon: <FaBoxOpen /> },
];

const Sidebar = ({ isOverlay = false, open, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const goTo = (path) => {
    navigate(path);
    if (onClose) onClose();
  };

  if (isOverlay) {
    return (
      <>
        {open && <div className="sidebar-overlay" onClick={onClose}></div>}
        <aside className={`sidebar overlay${open ? " open" : ""}`}>
          <div className="sidebar-logo">
            <img src={brandLogo} alt="Roha Jewellery logo" className="sidebar-logo__image" />
            <span>ROHA JEWELLERY</span>
            <small>Admin commerce suite</small>
          </div>
          <ul>
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={location.pathname === item.to ? "sidebar-link active" : "sidebar-link"}
                  onClick={(event) => {
                    event.preventDefault();
                    goTo(item.to);
                  }}
                >
                  <span style={{ fontSize: "1.3rem" }}>{item.icon}</span>
                  <span className="sidebar-label">{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
      </>
    );
  }
  return (
    <aside className="sidebar sidebar-horizontal">
      <div className="sidebar-logo">
        <img src={brandLogo} alt="Roha Jewellery logo" className="sidebar-logo__image" />
        <span>ROHA JEWELLERY</span>
        <small>Admin commerce suite</small>
      </div>
      <ul>
        {navItems.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              className={location.pathname === item.to ? "sidebar-link active" : "sidebar-link"}
              onClick={(event) => {
                event.preventDefault();
                goTo(item.to);
              }}
            >
              <span style={{ fontSize: "1.1rem" }}>{item.icon}</span>
              <span className="sidebar-label">{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
      <div className="sidebar-summary">
        <div className="sidebar-summary__card">
          <FaImages />
          <div>
            <strong>Brand first</strong>
            <p>Manage products, campaigns, requests, and premium storefront consistency from one polished dashboard.</p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
